"use strict";import{html as i}from"@cisco-u/base";export function starOne({height:C=293,width:e=293,hidden:t=!1,title:l="",fill:a="#C3C4C5"}={}){return i`<svg
    width=${e}
    height=${C}
    viewBox="0 0 293 293"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${t?"true":"false"}"
    aria-label="${l}"
  >
    <path
      d="M292.676 146.345C292.676 165.189 274.856 180.36 268.053 196.746C261.001 213.746 262.625 237.008 249.809 249.809C236.993 262.611 213.746 261.001 196.746 268.053C180.36 274.856 165.189 292.676 146.345 292.676C127.502 292.676 112.374 274.856 95.9297 268.053C78.9295 261.001 55.6676 262.611 42.8663 249.809C30.0649 237.008 31.6742 213.746 24.6225 196.746C17.8341 180.36 0 165.189 0 146.345C0 127.502 17.8341 112.272 24.5932 95.9298C31.645 78.9296 30.0357 55.6676 42.837 42.8663C55.6384 30.0649 78.9003 31.6742 95.9005 24.6225C112.286 17.8341 127.458 0 146.316 0C165.174 0 180.331 17.8341 196.717 24.6225C213.717 31.6742 236.979 30.0649 249.78 42.8663C262.582 55.6676 260.972 78.9296 268.024 95.9298C274.856 112.272 292.676 127.487 292.676 146.345Z"
      fill=${a}
    />
  </svg>`}
//# sourceMappingURL=starOne.js.map
